import React, { useTransition } from "react";
import { useTranslation } from "react-i18next";
import { FaStar, FaTruck } from "react-icons/fa";

export default function RatingMessageCard({ data }) {
    const { t } = useTranslation();
    if (!data) return null;

    const avg = data.average ?? 0;
    const stars = "★".repeat(Math.round(avg)) + "☆".repeat(5 - Math.round(avg));

    return (
        <div
        style={{
            minWidth: 240,
            maxWidth: 320,
            borderRadius: 12,
            overflow: "hidden",
            border: "1px solid #a7f3d0",
            background: "#ecfdf5",
        }}
        >
        {/* Route bar */}
        <div
            className="d-flex align-items-center gap-2 px-3 py-2 text-white"
            style={{ background: "#0d9f6e", fontSize: 12 }}
        >
            <FaTruck size={12} />
            <span className="text-truncate">{data.from}</span>
            <span>→</span>
            <span className="text-truncate">{data.to}</span>
        </div>

        <div className="p-3">
            <div className="fw-bold mb-1 text-dark" style={{ fontSize: 14 }}>
            {t('driverCompleted.driverInfo.rating')}
            </div>
            <div className="text-muted small mb-2">
            {t('clientDetails.order')}: {data.booking_id ?? 'NAN'}
            </div>
            <div className="d-flex align-items-center gap-2 mb-1">
            <span className="text-dark">{t('driverCard.driverDetails.averageRating')}:</span>
            <span style={{ color: "#f5b301", letterSpacing: 1 }}>{stars}</span>
            <strong className="text-dark">{Number(avg).toFixed(1)}</strong>
            </div>
            {data.comment && (
            <div className="small text-muted mt-2" style={{ fontStyle: "italic" }}>
                „{data.comment}”
            </div>
            )}
        </div>
        </div>
    );
}